import { Component} from '@angular/core';
import { ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-compare-wifi6',
  templateUrl: './compare-wifi6.component.html',
  styleUrls: ['./compare-wifi6.component.scss'],
})
export class CompareWifi6Component {
  constructor(readonly route: ActivatedRoute) {}
  scrollToSection(section: string) {
    const element = document.getElementById(section);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }
  slideConfig = {
    speed: 300,
    slidesToShow: 3,
    autoplaySpeed: 2000,
    slidesToScroll: 1,
    cssEase: 'linear',
    fade: false,
    autoplay: false,
    dots: false,
    draggable: true,
    arrows: false,
    centerMode: false,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 3,
          dots: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          dots: true,
        },
      },

      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          dots: true,
        },
      },
    ],
  };
  compareList: any = [
    {
      icon: 'https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landing-wifi6/sosanh-wifi.png',
      title: 'WI-FI THẾ HỆ MỚI NHẤT',
      content: 'Công nghệ hàng đầu, thiết bị hiện đại số 1',
    },
    {
      icon: 'https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landing-wifi6/sosanh-ketnoi.png',
      title: 'KẾT NỐI VƯỢT TRỘI',
      content: 'Sóng Internet rộng hơn, nhanh hơn, mạnh hơn gấp 4 lần',
    },
    {
      icon: 'https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landing-wifi6/sosanh-phusong.png',
      title: 'PHỦ SÓNG KHÔNG GIỚI HẠN',
      content:
        'Phủ sóng Wi-Fi xuyên tường, giải trí đa nền tảng trên nhiều thiết bị cùng lúc',
    },
  ];
  ngAfterViewInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      const section = params['section'];
      if (section) {
        this.scrollToSection(section);
      }
    });
  }
}
